/** Small id helper so `mockPlatformApiClient.ts` doesn't need a real UUIDv7 dependency
 * (unlike `packages/database-client`, this app never sends an id to a real backend that
 * cares about UUIDv7's sort property) — `crypto.randomUUID()` is plenty for mock-store
 * bookkeeping, with a non-crypto fallback for any environment lacking it. */
export function newId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `mock-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}
